import React from 'react'
import Faq from './Faq'
import { useUserAuth } from '../context/UserAuthContext'

const Help = () => {
    const {language} = useUserAuth()
    return (
        <div className='page-wrapper'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className="card-header text-white bg-primary">
                            {language === 'en' ? `Hi, how can we help you?` : `नमस्ते, हम आपकी कैसे मदद कर सकते हैं?`}
                            </div>
                            <div className='card-body'>
                                <Faq/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Help